export default __webpack_public_path__ + "maps-examples-line-gradient-1200-806dd1d48bcd455b1dd3011048698c9d.webp";